import { yodaInfoConstants } from "../constants";

const infoReducer = (
  state = {
    loading: false,
    cookie: [],
    privacy: [],
    sizeScale: [],
  },
  action,
) => {
  switch (action.type) {
    // ------ COOKIES------
    case yodaInfoConstants.GETCOOKIE_ALL_REQUEST:
      return {
        ...state,
        loading: true,
        cookie: state.cookie,
      };

    case yodaInfoConstants.GETCOOKIE_ALL_SUCCESS:
      return {
        ...state,
        cookie: action.payload.cookie,
        loading: false,
      };

    case yodaInfoConstants.GETCOOKIE_ALL_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };

    // ------ PRIVACY------
    case yodaInfoConstants.GETPRIVACY_ALL_REQUEST:
      return {
        ...state,
        loading: true,
        privacy: state.privacy,
      };

    case yodaInfoConstants.GETPRIVACY_ALL_SUCCESS:
      return {
        ...state,
        privacy: action.payload.privacy,
        loading: false,
      };

    case yodaInfoConstants.GETPRIVACY_ALL_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };

    // ------ SIZE SCALE------
    case yodaInfoConstants.GETSIZE_ALL_REQUEST:
      return {
        ...state,
        sizeScale: state.sizeScale,
        loading: false,
      };

    case yodaInfoConstants.GETSCALESIZE_ALL_SUCCESS:
      return {
        ...state,
        sizeScale: action.payload.sizeScale,
        loading: false,
      };

    case yodaInfoConstants.GETSCALESIZE_ALL_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };

    // ------ DEFAULT------
    default:
      return state;
  }
};

export default infoReducer;
